import round from "../round";

/**
 *
 * @param {String} hex
 * @param {Boolean} alpha
 * @param {String} separator
 */
const joinRGBA = (hex, alpha, separator) => {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const a = alpha ? round(parseInt(hex.slice(6, 8), 16) / 255, 2) : 1;

  return `rgba(${r}${separator}${g}${separator}${b}${separator}${a})`;
};

export default joinRGBA;
